import PolygonBase from './PolygonBase';
import shapeCircle from '../assets/icons/shapeCircle.svg';
import { svgToIcon } from '../utils/svg';

class ShapeCircle extends PolygonBase {
  static renderIcon() {
    return svgToIcon(shapeCircle);
  }

  changedToShape() {
    super.changedToShape();

    // circle width/height must be equivalent, but that's not the case for all shapes, so enforce it when changing
    this.fabricObject.set('width', this.fabricObject.height);
  }

  calcTextMargin() {
    const { width, height } = this.fabricObject;

    const horizontalBound = width / 7;
    const verticalBound = height / 7;

    return {
      top: verticalBound,
      left: horizontalBound,
      right: horizontalBound,
      bottom: verticalBound,
    };
  }

  static pathString() {
    return `
      M 0.5 0
      a 0.5,0.5 0 0,1 -1,0
      a 0.5,0.5 0 0,1 1,0
      Z
    `;
  }
}

export default ShapeCircle;
